import * as constants from './constants';

export const processStateMV = {
  Appointment: {
    nextStep: 'OrderReview',
    nextViewPage: 'orderReview.html',
    currentStep: 'Appointment',
    previousStep: 'Setup',
  },
  OrderReview: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'OrderReview',
    previousStep: 'Appointment',
  },
  Confirmation: {
    nextStep: 'Home',
    nextViewPage: '/',
    currentStep: 'Confirmation',
    previousStep: 'OrderReview',
  },
};

const progressStateMV = {
  Appointment: {
    isCompleted: true,
    isActive: false,
    progress: 60,
    currentPage: true,
  },
  OrderReview: {
    isCompleted: false,
    isActive: false,
    progress: 80,
    currentPage: false,
  },
  Confirmation: {
    isCompleted: false,
    isActive: false,
    progress: 100,
    currentPage: false,
  },
};

export const progressStepsMV = (state = progressStateMV, action) => {
  switch (action.type) {
    case constants.UPDATE_PLANS_MV: {
      const confirmationProgress = { ...state.Confirmation, isCompleted: false, isActive: false };
      const setupProgress = { ...state.Setup, isCompleted: false, isActive: false };
      const plansProgress = { ...state.Plans, isCompleted: action.response, isActive: action.response };
      return {
        ...state,
        Plans: plansProgress,
        Setup: setupProgress,
        Confirmation: confirmationProgress,
      };
    }
    case constants.UPDATE_COVID_MV:
    case constants.UPDATE_SETUP_MV:
    case constants.UPDATE_APPOINTMENT_MV:
    {
      const confirmationProgress = { ...state.Confirmation, isCompleted: false, isActive: false };
      const setupProgress = { ...state.Setup, isCompleted: action.response, isActive: action.response };
      const plansProgress = { ...state.Plans, isActive: false };

      return {
        ...state,
        Plans: plansProgress,
        Setup: setupProgress,
        Confirmation: confirmationProgress,
      };
    }
    case constants.UPDATE_REVIEWORDER_MV:
    {
      const confirmationProgress = { ...state.Confirmation, isCompleted: action.response, isActive: action.response };
      const setupProgress = { ...state.Setup, isCompleted: true, isActive: false };
      const plansProgress = { ...state.Plans, isActive: false };

      return {
        ...state,
        Plans: plansProgress,
        Setup: setupProgress,
        Confirmation: confirmationProgress,
      };
    }

    default:
      return state;
  }
};


export const processStepsMV = (state = processStateMV, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
